__turbopack_context__.v({
  "filter-body": "K5fu8G_filter-body",
  "filter-body-row": "K5fu8G_filter-body-row",
  "filter-body-title": "K5fu8G_filter-body-title",
  "filter-items-wrapper": "K5fu8G_filter-items-wrapper",
  "filter-mob": "K5fu8G_filter-mob",
  "filter-mob-close": "K5fu8G_filter-mob-close",
  "filter-wrapper": "K5fu8G_filter-wrapper",
  "filtered-by": "K5fu8G_filtered-by",
  "filters-list": "K5fu8G_filters-list",
  "layered-navigations": "K5fu8G_layered-navigations",
  "layered-navigations-srp": "K5fu8G_layered-navigations-srp",
  "open": "K5fu8G_open",
  "selected-items-clear-all": "K5fu8G_selected-items-clear-all",
  "selected-items-list": "K5fu8G_selected-items-list",
});
